import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow.ts'
import { ceilPrice } from 'shared/ui/price-dollar/lib/ceilPrice.ts'

import s from './styles.module.scss'

interface Props {
  som?: string
  dollar?: string
}

export const PriceDollar = ({ som, dollar }: Props) => {
  return (
    <div className={s.prices}>
      {som && (
        <div className={clsx('extra-bold-16', s.price)}>
          {`${priceShow(String(som))} `} &#8384;
        </div>
      )}

      {dollar && (
        <p className={clsx('semi-bold-14', s.dollar)}>
          (~&#36;
          {priceShow(ceilPrice(dollar))})
        </p>
      )}
    </div>
  )
}
